import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { EventsProvider } from "./context/EventsContext";
import HomePage from "./pages/HomePage";
import EventPage from "./pages/EventPage";
import ReservationSuccess from "./pages/ReservationSuccess";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminEventDetail from "./pages/admin/AdminEventDetail";
import EventForm from "./pages/admin/EventForm";
import LayoutEditor from "./pages/admin/LayoutEditor";
import AdminEventReservations from "./pages/admin/AdminEventReservations";
import QrScanner from "./pages/admin/QrScanner";
import PaymentMethodsAdmin from "./pages/admin/PaymentMethodsAdmin";
import ProtectedRoute from "./components/custom/ProtectedRoute";

function App() {
  return (
    <div className="App">
      {/* Noise Overlay */}
      <div className="noise-overlay" />
      
      <AuthProvider>
        <EventsProvider>
          <BrowserRouter>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              <Route path="/evento/:eventId" element={<EventPage />} />
              <Route path="/reserva/:uuid" element={<ReservationSuccess />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/events/new" element={
                <ProtectedRoute>
                  <EventForm />
                </ProtectedRoute>
              } />
              <Route path="/admin/events/:eventId/edit" element={
                <ProtectedRoute>
                  <EventForm />
                </ProtectedRoute>
              } />
              <Route path="/admin/events/:eventId" element={
                <ProtectedRoute>
                  <AdminEventDetail />
                </ProtectedRoute>
              } />
              <Route path="/admin/events/:eventId/layout" element={
                <ProtectedRoute>
                  <LayoutEditor />
                </ProtectedRoute>
              } />
              <Route path="/admin/events/:eventId/reservations" element={
                <ProtectedRoute>
                  <AdminEventReservations />
                </ProtectedRoute>
              } />
              <Route path="/admin/scanner" element={
                <ProtectedRoute>
                  <QrScanner />
                </ProtectedRoute>
              } />
              <Route path="/admin/payment-methods" element={
                <ProtectedRoute>
                  <PaymentMethodsAdmin />
                </ProtectedRoute>
              } />
            </Routes>
          </BrowserRouter>
        </EventsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
